var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessDenied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 194,
    viewBox: "0 0 250 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M225.91 90.292H211.363L198.019 82.1855L178.77 90.292H146.177L133.374 82.4424L113.583 90.292H89.7139V42.1113H128.13L139.061 55.3442L160.723 42.1113H193.316L206.64 53.6714L225.91 42.1113C239.214 42.1113 250 52.897 250 66.2017C250 79.5063 239.214 90.292 225.91 90.292Z",
    fill: "#F6F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9546 0.391602C38.9136 0.391602 20.2349 19.0703 20.2349 42.1113V175.514H103.674V42.1113C103.674 19.0698 84.9956 0.391602 61.9546 0.391602Z",
    fill: "#E7A52E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9771 1.1626C50.7769 4.90137 36.2793 21.8101 36.2793 42.1113V175.509H20.2344V42.1113C20.2344 19.0669 38.9121 0.388672 61.957 0.388672C64.7012 0.388672 67.3843 0.655273 69.9771 1.1626Z",
    fill: "#E4936B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.583 90.292L128.13 42.1113H160.723L146.177 90.292M178.77 90.292L193.316 42.1113H225.91L211.363 90.292",
    fill: "#DD636E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.876 162.146H16.0332C7.17822 162.146 0 169.324 0 178.179V193.611H123.909V178.179C123.909 169.324 116.731 162.146 107.876 162.146Z",
    fill: "#30579D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7578 162.149C29.9038 162.149 22.7231 169.325 22.7231 178.179V193.61H0V178.179C0 169.325 7.17578 162.149 16.0298 162.149H38.7578Z",
    fill: "#26457D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3018 121.373H54.6074C46.2065 121.373 39.396 114.562 39.396 106.161V63.3936C39.396 54.9927 46.2065 48.1821 54.6074 48.1821H69.3018C77.7026 48.1821 84.5132 54.9927 84.5132 63.3936V106.161C84.5132 114.562 77.7031 121.373 69.3018 121.373Z",
    fill: "#F6F9F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.981 73.0098H51.9287C50.9282 73.0098 49.9687 72.6123 49.2612 71.9048C48.5537 71.1974 48.1562 70.2378 48.1562 69.2373C48.1562 68.2368 48.5537 67.2772 49.2612 66.5698C49.9687 65.8623 50.9282 65.4648 51.9287 65.4648H71.981C72.9815 65.4648 73.941 65.8623 74.6485 66.5698C75.356 67.2772 75.7534 68.2368 75.7534 69.2373C75.7534 70.2378 75.356 71.1974 74.6485 71.9048C73.941 72.6123 72.9815 73.0098 71.981 73.0098ZM71.981 88.5503H51.9287C50.9282 88.5503 49.9687 88.1528 49.2612 87.4454C48.5537 86.7379 48.1562 85.7783 48.1562 84.7778C48.1562 83.7773 48.5537 82.8178 49.2612 82.1103C49.9687 81.4028 50.9282 81.0054 51.9287 81.0054H71.981C72.9815 81.0054 73.941 81.4028 74.6485 82.1103C75.356 82.8178 75.7534 83.7773 75.7534 84.7778C75.7534 85.7783 75.356 86.7379 74.6485 87.4454C73.941 88.1528 72.9815 88.5503 71.981 88.5503Z",
    fill: "#DD636E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDenied);
export default __webpack_public_path__ + "static/media/accessDenied.44609c41368fc3ff3f93b887e101edaf.svg";
export { ForwardRef as ReactComponent };